// Mock data for my tm brand website

export const pricingPlans = [
  {
    id: 1,
    name: 'Essentials',
    price: '$45',
    fee: '+ Federal Filing Fee',
    features: [
      'Case Review',
      'Case Filing',
      'Basic Search',
      'State E-Filing',
      'Trademark Secured'
    ],
    note: '(Govt. filing fee not included)',
    recommended: false
  },
  {
    id: 2,
    name: 'Enhanced',
    price: '$149',
    fee: '+ Federal Filing Fee',
    features: [
      'Case Review',
      'Case Filing',
      'Direct Hit Search',
      'Trademark Alert',
      'Trademark Secured',
      'High Satisfaction Rate',
      'Refusal Risk Meter'
    ],
    note: '(Govt. filing fee not included)',
    recommended: false
  },
  {
    id: 3,
    name: 'Deluxe',
    price: '$299',
    fee: '+ Federal Filing Fee',
    features: [
      'Case Review',
      'Case Filing',
      'Direct Hit Search',
      'Trademark Alert',
      'Trademark Secured',
      'High Satisfaction Rate',
      'Refusal Risk Meter',
      'Trademark Monitoring',
      'Complete Documentation',
      'Digital File',
      'Dedicated Case Manager'
    ],
    note: '(Govt. filing fee not included)',
    recommended: true
  },
  {
    id: 4,
    name: 'Platinum',
    price: '$349',
    fee: '+ Federal Filing Fee',
    features: [
      'Case Review',
      'Case Filing',
      'Direct Hit Search',
      'Trademark Alert',
      'Trademark Secured',
      'High Satisfaction Rate',
      'Refusal Risk Meter',
      'Trademark Monitoring',
      'Complete Documentation',
      'Digital File',
      'Dedicated Case Manager',
      'High Approval Rate',
      'Comprehensive Search Report',
      'High Priority Service',
      'Cease & Desist Letter'
    ],
    note: '(Govt. filing fee not included)',
    recommended: false
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Sarah Mitchell',
    company: 'Mitchell Designs LLC',
    text: 'The trademark registration process was seamless. The team guided us through every step and secured our brand protection efficiently.',
    rating: 5
  },
  {
    id: 2,
    name: 'James Rodriguez',
    company: 'TechFlow Inc',
    text: 'Outstanding service! They handled our trademark registration professionally and kept us informed throughout the entire process.',
    rating: 5
  },
  {
    id: 3,
    name: 'Emily Chen',
    company: 'Bloom Botanicals',
    text: 'Highly recommend! The comprehensive search and monitoring services gave us peace of mind for our brand protection.',
    rating: 5
  },
  {
    id: 4,
    name: 'Michael Thompson',
    company: 'Urban Eats',
    text: 'Professional, responsive, and knowledgeable. They made trademark registration straightforward and stress-free.',
    rating: 5
  },
  {
    id: 5,
    name: 'Lisa Anderson',
    company: 'Artisan Crafts Co',
    text: 'Excellent experience from start to finish. The dedicated case manager was incredibly helpful and responsive.',
    rating: 5
  },
  {
    id: 6,
    name: 'David Park',
    company: 'Park & Associates',
    text: 'Fast, efficient, and professional trademark services. They exceeded our expectations with their attention to detail.',
    rating: 5
  },
  {
    id: 7,
    name: 'Rachel Green',
    company: 'Green Solutions',
    text: 'The best investment we made for our business. Our trademark was registered quickly and the process was transparent.',
    rating: 5
  },
  {
    id: 8,
    name: 'Tom Bradley',
    company: 'Bradley Tech',
    text: 'Exceptional service and expertise. They made the complex trademark process simple and easy to understand.',
    rating: 5
  },
  {
    id: 9,
    name: 'Nina Patel',
    company: 'Patel Consulting',
    text: 'Highly professional team that delivered exactly what they promised. Our brand is now fully protected.',
    rating: 5
  },
  {
    id: 10,
    name: 'Gregory Foster',
    company: 'Foster Industries',
    text: 'Working with this team was a game-changer for our brand protection strategy. Highly recommend their expertise.',
    rating: 5
  },
  {
    id: 11,
    name: 'Samantha Lee',
    company: 'Lee Enterprises',
    text: 'Professional service from start to finish. They made trademark registration easy and stress-free for our startup.',
    rating: 5
  },
  {
    id: 12,
    name: 'Marcus Johnson',
    company: 'Johnson & Co',
    text: 'The attention to detail and customer service exceeded our expectations. Our brand is now fully protected.',
    rating: 5
  }
];

export const processSteps = [
  {
    id: 1,
    step: 'Step 1',
    title: 'Consultation & Search',
    description: 'We review your trademark and conduct a comprehensive search to ensure availability and registrability.',
    icon: 'Search'
  },
  {
    id: 2,
    step: 'Step 2',
    title: 'Application Preparation',
    description: 'Our experts prepare and file your trademark application with accurate classifications and descriptions.',
    icon: 'FileText'
  },
  {
    id: 3,
    step: 'Step 3',
    title: 'Filing & Monitoring',
    description: 'We file your application with the USPTO and monitor its progress, handling any office actions promptly.',
    icon: 'Send'
  },
  {
    id: 4,
    step: 'Step 4',
    title: 'Registration & Protection',
    description: 'Upon approval, your trademark is registered and we provide ongoing monitoring and protection services.',
    icon: 'Shield'
  }
];

export const serviceCategories = [
  {
    id: 'trademark',
    name: 'Trademark Registration',
    items: [
      { name: 'Register Your Trademark', path: '/services/register-trademark', description: 'Secure brand rights with comprehensive federal registration' },
      { name: 'TTAB Petition', path: '/services/ttab-petition', description: 'Expert representation for trademark appeals and disputes' },
      { name: 'Clearance Search Services', path: '/services/clearance-search', description: 'Thorough searches to ensure trademark availability' },
      { name: 'Trademark Ownership Transfers', path: '/services/ownership-transfers', description: 'Seamless transfer of trademark ownership rights' },
      { name: 'Managed Trademark Renewal', path: '/services/trademark-renewal', description: 'Timely renewal to maintain trademark protection' },
      { name: 'Submission of Statements of Use', path: '/services/statements-of-use', description: 'Complete your registration with proof of use' },
      { name: 'Support & Response for Trademark Office Actions', path: '/services/office-actions', description: 'Expert handling of USPTO office action responses' },
      { name: 'Active Monitoring for Trademark Infringement', path: '/services/infringement-monitoring', description: 'Continuous monitoring to protect your brand identity' },
      { name: 'Support & Guidance for Trademark Cancellations', path: '/services/trademark-cancellations', description: 'Strategic guidance for trademark cancellation proceedings' },
      { name: 'Legal Representation for Trademark Disputes', path: '/services/trademark-disputes', description: 'Skilled representation in trademark litigation matters' },
      { name: 'Combatting Counterfeiting & Trademark Infringement', path: '/services/counterfeiting', description: 'Aggressive enforcement against counterfeit goods' }
    ]
  },
  {
    id: 'copyright',
    name: 'Copyright Registration',
    items: [
      { name: 'Register Your Copyright', path: '/services/register-copyright', description: 'Protect your creative works with federal registration' },
      { name: 'Copyright Enforcement Assistance', path: '/services/copyright-enforcement', description: 'Take action against unauthorized use of your work' },
      { name: 'Copyright Transfers & Licensing Support', path: '/services/copyright-transfers', description: 'Navigate copyright transfers and licensing agreements' },
      { name: 'Legal Representation for Copyright', path: '/services/copyright-legal', description: 'Expert legal counsel for copyright matters' },
      { name: 'Copyright Portfolio Management', path: '/services/copyright-portfolio', description: 'Comprehensive management of your copyright assets' },
      { name: 'DMCA Compliance', path: '/services/dmca-compliance', description: 'Ensure compliance with digital copyright regulations' }
    ]
  },
  {
    id: 'patent',
    name: 'Patent Services',
    items: [
      { name: 'Existing Patent Search', path: '/services/patent-search', description: 'Comprehensive search to identify existing patents' },
      { name: 'Response to Patent Office Actions', path: '/services/patent-office-actions', description: 'Professional responses to USPTO patent office actions' },
      { name: 'Patent Application Submission', path: '/services/patent-application', description: 'Complete patent application preparation and filing' },
      { name: 'Legal Representation for Patent Protection', path: '/services/patent-protection', description: 'Expert legal representation for patent matters' }
    ]
  },
  {
    id: 'company',
    name: 'Company Formation',
    items: [
      { name: 'LLC', path: '/services/llc-formation', description: 'Form a limited liability company for flexible business structure' },
      { name: 'C Corporation', path: '/services/c-corporation', description: 'Establish a C Corp for traditional corporate structure' },
      { name: 'S Corporation', path: '/services/s-corporation', description: 'Create an S Corp for pass-through tax benefits' },
      { name: 'Non-Profit', path: '/services/non-profit', description: 'Set up a non-profit organization with tax-exempt status' }
    ]
  },
  {
    id: 'legal',
    name: 'Legal Services',
    items: [
      { name: 'Legal Consultation on Partnerships & LLPs', path: '/services/partnerships', description: 'Expert guidance on partnership agreements and structures' },
      { name: 'Due Diligence', path: '/services/due-diligence', description: 'Thorough review for business transactions and investments' },
      { name: 'Business Immigration Law', path: '/services/immigration-law', description: 'Navigate work visas and business immigration matters' },
      { name: 'IT & Commercial Law', path: '/services/commercial-law', description: 'Legal support for technology and commercial agreements' },
      { name: 'Data Protection & Privacy Law', path: '/services/data-protection', description: 'Compliance with data protection and privacy regulations' }
    ]
  },
  {
    id: 'additional',
    name: 'Additional Services',
    items: [
      { name: 'Amazon Brand Registry (US)', path: '/services/amazon-brand-registry', description: 'Register your brand for Amazon marketplace protection' },
      { name: 'Business Formation Services', path: '/services/business-formation', description: 'Complete business entity formation and setup' },
      { name: 'Company Dissolution', path: '/services/company-dissolution', description: 'Properly dissolve your business entity' },
      { name: 'Issue of Shares', path: '/services/issue-shares', description: 'Issue new shares and manage equity distribution' },
      { name: 'Transfer of Shares', path: '/services/transfer-shares', description: 'Facilitate share transfer transactions' },
      { name: 'Certificate of Good Standing', path: '/services/good-standing', description: 'Obtain certificates for business compliance verification' },
      { name: 'Company Name Change', path: '/services/name-change', description: 'Process legal name changes for your business' },
      { name: 'Company Renewals', path: '/services/company-renewals', description: 'Annual renewal and compliance filings' },
      { name: 'Nominee Director & Secretarial Services', path: '/services/nominee-director', description: 'Professional nominee director and company secretary services' },
      { name: 'Bookkeeping', path: '/services/bookkeeping', description: 'Accurate bookkeeping and financial record maintenance' },
      { name: 'Tax Advisory & Filing', path: '/services/tax-advisory', description: 'Expert tax planning and filing services' },
      { name: 'CFO Services', path: '/services/cfo-services', description: 'Fractional CFO services for financial management' }
    ]
  }
];

export const countryCodes = [
  { code: '+1', country: 'USA/Canada' },
  { code: '+7', country: 'Russia' },
  { code: '+20', country: 'Egypt' },
  { code: '+27', country: 'South Africa' },
  { code: '+30', country: 'Greece' },
  { code: '+31', country: 'Netherlands' },
  { code: '+32', country: 'Belgium' },
  { code: '+33', country: 'France' },
  { code: '+34', country: 'Spain' },
  { code: '+36', country: 'Hungary' },
  { code: '+39', country: 'Italy' },
  { code: '+40', country: 'Romania' },
  { code: '+41', country: 'Switzerland' },
  { code: '+43', country: 'Austria' },
  { code: '+44', country: 'UK' },
  { code: '+45', country: 'Denmark' },
  { code: '+46', country: 'Sweden' },
  { code: '+47', country: 'Norway' },
  { code: '+48', country: 'Poland' },
  { code: '+49', country: 'Germany' },
  { code: '+51', country: 'Peru' },
  { code: '+52', country: 'Mexico' },
  { code: '+53', country: 'Cuba' },
  { code: '+54', country: 'Argentina' },
  { code: '+55', country: 'Brazil' },
  { code: '+56', country: 'Chile' },
  { code: '+57', country: 'Colombia' },
  { code: '+58', country: 'Venezuela' },
  { code: '+60', country: 'Malaysia' },
  { code: '+61', country: 'Australia' },
  { code: '+62', country: 'Indonesia' },
  { code: '+63', country: 'Philippines' },
  { code: '+64', country: 'New Zealand' },
  { code: '+65', country: 'Singapore' },
  { code: '+66', country: 'Thailand' },
  { code: '+81', country: 'Japan' },
  { code: '+82', country: 'South Korea' },
  { code: '+84', country: 'Vietnam' },
  { code: '+86', country: 'China' },
  { code: '+90', country: 'Turkey' },
  { code: '+91', country: 'India' },
  { code: '+92', country: 'Pakistan' },
  { code: '+93', country: 'Afghanistan' },
  { code: '+94', country: 'Sri Lanka' },
  { code: '+95', country: 'Myanmar' },
  { code: '+98', country: 'Iran' },
  { code: '+212', country: 'Morocco' },
  { code: '+213', country: 'Algeria' },
  { code: '+216', country: 'Tunisia' },
  { code: '+218', country: 'Libya' },
  { code: '+220', country: 'Gambia' },
  { code: '+221', country: 'Senegal' },
  { code: '+223', country: 'Mali' },
  { code: '+224', country: 'Guinea' },
  { code: '+225', country: 'Ivory Coast' },
  { code: '+226', country: 'Burkina Faso' },
  { code: '+227', country: 'Niger' },
  { code: '+228', country: 'Togo' },
  { code: '+229', country: 'Benin' },
  { code: '+230', country: 'Mauritius' },
  { code: '+231', country: 'Liberia' },
  { code: '+232', country: 'Sierra Leone' },
  { code: '+233', country: 'Ghana' },
  { code: '+234', country: 'Nigeria' },
  { code: '+235', country: 'Chad' },
  { code: '+236', country: 'Central African Republic' },
  { code: '+237', country: 'Cameroon' },
  { code: '+238', country: 'Cape Verde' },
  { code: '+239', country: 'Sao Tome and Principe' },
  { code: '+240', country: 'Equatorial Guinea' },
  { code: '+241', country: 'Gabon' },
  { code: '+242', country: 'Congo' },
  { code: '+243', country: 'DR Congo' },
  { code: '+244', country: 'Angola' },
  { code: '+245', country: 'Guinea-Bissau' },
  { code: '+246', country: 'British Indian Ocean Territory' },
  { code: '+248', country: 'Seychelles' },
  { code: '+249', country: 'Sudan' },
  { code: '+250', country: 'Rwanda' },
  { code: '+251', country: 'Ethiopia' },
  { code: '+252', country: 'Somalia' },
  { code: '+253', country: 'Djibouti' },
  { code: '+254', country: 'Kenya' },
  { code: '+255', country: 'Tanzania' },
  { code: '+256', country: 'Uganda' },
  { code: '+257', country: 'Burundi' },
  { code: '+258', country: 'Mozambique' },
  { code: '+260', country: 'Zambia' },
  { code: '+261', country: 'Madagascar' },
  { code: '+262', country: 'Reunion' },
  { code: '+263', country: 'Zimbabwe' },
  { code: '+264', country: 'Namibia' },
  { code: '+265', country: 'Malawi' },
  { code: '+266', country: 'Lesotho' },
  { code: '+267', country: 'Botswana' },
  { code: '+268', country: 'Swaziland' },
  { code: '+269', country: 'Comoros' },
  { code: '+350', country: 'Gibraltar' },
  { code: '+351', country: 'Portugal' },
  { code: '+352', country: 'Luxembourg' },
  { code: '+353', country: 'Ireland' },
  { code: '+354', country: 'Iceland' },
  { code: '+355', country: 'Albania' },
  { code: '+356', country: 'Malta' },
  { code: '+357', country: 'Cyprus' },
  { code: '+358', country: 'Finland' },
  { code: '+359', country: 'Bulgaria' },
  { code: '+370', country: 'Lithuania' },
  { code: '+371', country: 'Latvia' },
  { code: '+372', country: 'Estonia' },
  { code: '+373', country: 'Moldova' },
  { code: '+374', country: 'Armenia' },
  { code: '+375', country: 'Belarus' },
  { code: '+376', country: 'Andorra' },
  { code: '+377', country: 'Monaco' },
  { code: '+378', country: 'San Marino' },
  { code: '+380', country: 'Ukraine' },
  { code: '+381', country: 'Serbia' },
  { code: '+382', country: 'Montenegro' },
  { code: '+383', country: 'Kosovo' },
  { code: '+385', country: 'Croatia' },
  { code: '+386', country: 'Slovenia' },
  { code: '+387', country: 'Bosnia and Herzegovina' },
  { code: '+389', country: 'North Macedonia' },
  { code: '+420', country: 'Czech Republic' },
  { code: '+421', country: 'Slovakia' },
  { code: '+423', country: 'Liechtenstein' },
  { code: '+500', country: 'Falkland Islands' },
  { code: '+501', country: 'Belize' },
  { code: '+502', country: 'Guatemala' },
  { code: '+503', country: 'El Salvador' },
  { code: '+504', country: 'Honduras' },
  { code: '+505', country: 'Nicaragua' },
  { code: '+506', country: 'Costa Rica' },
  { code: '+507', country: 'Panama' },
  { code: '+509', country: 'Haiti' },
  { code: '+591', country: 'Bolivia' },
  { code: '+592', country: 'Guyana' },
  { code: '+593', country: 'Ecuador' },
  { code: '+594', country: 'French Guiana' },
  { code: '+595', country: 'Paraguay' },
  { code: '+596', country: 'Martinique' },
  { code: '+597', country: 'Suriname' },
  { code: '+598', country: 'Uruguay' },
  { code: '+599', country: 'Netherlands Antilles' },
  { code: '+670', country: 'East Timor' },
  { code: '+672', country: 'Antarctica' },
  { code: '+673', country: 'Brunei' },
  { code: '+674', country: 'Nauru' },
  { code: '+675', country: 'Papua New Guinea' },
  { code: '+676', country: 'Tonga' },
  { code: '+677', country: 'Solomon Islands' },
  { code: '+678', country: 'Vanuatu' },
  { code: '+679', country: 'Fiji' },
  { code: '+680', country: 'Palau' },
  { code: '+681', country: 'Wallis and Futuna' },
  { code: '+682', country: 'Cook Islands' },
  { code: '+683', country: 'Niue' },
  { code: '+685', country: 'Samoa' },
  { code: '+686', country: 'Kiribati' },
  { code: '+687', country: 'New Caledonia' },
  { code: '+688', country: 'Tuvalu' },
  { code: '+689', country: 'French Polynesia' },
  { code: '+690', country: 'Tokelau' },
  { code: '+691', country: 'Micronesia' },
  { code: '+692', country: 'Marshall Islands' },
  { code: '+850', country: 'North Korea' },
  { code: '+852', country: 'Hong Kong' },
  { code: '+853', country: 'Macau' },
  { code: '+855', country: 'Cambodia' },
  { code: '+856', country: 'Laos' },
  { code: '+880', country: 'Bangladesh' },
  { code: '+886', country: 'Taiwan' },
  { code: '+960', country: 'Maldives' },
  { code: '+961', country: 'Lebanon' },
  { code: '+962', country: 'Jordan' },
  { code: '+963', country: 'Syria' },
  { code: '+964', country: 'Iraq' },
  { code: '+965', country: 'Kuwait' },
  { code: '+966', country: 'Saudi Arabia' },
  { code: '+967', country: 'Yemen' },
  { code: '+968', country: 'Oman' },
  { code: '+970', country: 'Palestine' },
  { code: '+971', country: 'UAE' },
  { code: '+972', country: 'Israel' },
  { code: '+973', country: 'Bahrain' },
  { code: '+974', country: 'Qatar' },
  { code: '+975', country: 'Bhutan' },
  { code: '+976', country: 'Mongolia' },
  { code: '+977', country: 'Nepal' },
  { code: '+992', country: 'Tajikistan' },
  { code: '+993', country: 'Turkmenistan' },
  { code: '+994', country: 'Azerbaijan' },
  { code: '+995', country: 'Georgia' },
  { code: '+996', country: 'Kyrgyzstan' },
  { code: '+998', country: 'Uzbekistan' }
];

export const images = {
  hero: 'https://images.pexels.com/photos/2381069/pexels-photo-2381069.jpeg',
  about: 'https://images.unsplash.com/photo-1709715357520-5e1047a2b691',
  services: 'https://images.unsplash.com/photo-1730382624709-81e52dd294d4',
  process: 'https://images.unsplash.com/photo-1517048676732-d65bc937f952',
  growth: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f',
  team: 'https://images.pexels.com/photos/3183150/pexels-photo-3183150.jpeg',
  analysis: 'https://images.pexels.com/photos/590022/pexels-photo-590022.jpeg',
  workflow: 'https://images.unsplash.com/photo-1573164574572-cb89e39749b4'
};

// Service-specific testimonials
export const serviceTestimonials = {
  trademark: [
    { name: 'Jennifer Martinez', company: 'Martinez Consulting', text: 'The trademark registration was handled professionally from start to finish. Our brand is now fully protected.', rating: 5 },
    { name: 'Robert Williams', company: 'Williams Tech Solutions', text: 'Fast and efficient trademark filing service. They made the complex process simple and straightforward.', rating: 5 },
    { name: 'Amanda Brown', company: 'Brown Design Studio', text: 'Excellent trademark services! The team was knowledgeable and responsive throughout the entire process.', rating: 5 },
    { name: 'Richard Cooper', company: 'Cooper Brands', text: 'Outstanding trademark protection service. The team was professional and made everything incredibly easy.', rating: 5 },
    { name: 'Karen Phillips', company: 'Phillips Marketing', text: 'Best trademark service I have used. They handled everything efficiently and kept me informed every step.', rating: 5 },
    { name: 'Timothy Scott', company: 'Scott Ventures', text: 'Exceptional trademark registration experience. Professional, fast, and highly recommended for any business.', rating: 5 }
  ],
  copyright: [
    { name: 'Christopher Davis', company: 'Davis Creative Agency', text: 'Outstanding copyright registration service. They protected our creative works quickly and efficiently.', rating: 5 },
    { name: 'Michelle Johnson', company: 'Johnson Photography', text: 'Professional and thorough copyright protection. I highly recommend their services to all creators.', rating: 5 },
    { name: 'Daniel Garcia', company: 'Garcia Productions', text: 'The copyright registration process was seamless. Great communication and expert guidance throughout.', rating: 5 },
    { name: 'Victoria Turner', company: 'Turner Studios', text: 'Excellent copyright services for our creative content. The team made the process simple and efficient.', rating: 5 },
    { name: 'Brandon Mitchell', company: 'Mitchell Media', text: 'Professional copyright protection that exceeded expectations. Highly recommend to all content creators.', rating: 5 },
    { name: 'Angela Roberts', company: 'Roberts Creative', text: 'Best copyright registration service. They protected our intellectual property with expertise and care.', rating: 5 }
  ],
  patent: [
    { name: 'Patricia Wilson', company: 'Wilson Innovations', text: 'Expert patent services that helped protect our invention. The team was knowledgeable and professional.', rating: 5 },
    { name: 'Kevin Moore', company: 'Moore Technologies', text: 'Exceptional patent filing assistance. They understood our technical requirements and delivered perfectly.', rating: 5 },
    { name: 'Laura Taylor', company: 'Taylor R&D Labs', text: 'Comprehensive patent protection services. The team guided us through every step with expertise.', rating: 5 }
  ],
  company: [
    { name: 'Steven Anderson', company: 'Anderson Ventures', text: 'LLC formation was quick and hassle-free. Professional service and great attention to detail.', rating: 5 },
    { name: 'Jessica Thomas', company: 'Thomas Enterprises', text: 'Excellent company formation services. They handled all the paperwork and made everything easy.', rating: 5 },
    { name: 'Brian Jackson', company: 'Jackson Holdings', text: 'Professional and efficient business formation. Highly recommend for anyone starting a new company.', rating: 5 }
  ],
  search: [
    { name: 'Rebecca White', company: 'White Marketing Group', text: 'Thorough trademark search that saved us from potential conflicts. Very professional and detailed.', rating: 5 },
    { name: 'William Harris', company: 'Harris Consulting', text: 'Comprehensive search service that gave us confidence in our trademark choice. Excellent work.', rating: 5 },
    { name: 'Stephanie Martin', company: 'Martin Media', text: 'The clearance search was detailed and helped us make informed decisions about our brand.', rating: 5 }
  ],
  amazon: [
    { name: 'Andrew Thompson', company: 'Thompson E-commerce', text: 'Amazon Brand Registry setup was smooth and professional. Our products are now better protected.', rating: 5 },
    { name: 'Nicole Lee', company: 'Lee Online Store', text: 'Expert help with Amazon Brand Registry. The process was straightforward with their guidance.', rating: 5 },
    { name: 'Matthew Clark', company: 'Clark Trading Co', text: 'Professional Amazon Brand Registry services. They made the enrollment process easy and efficient.', rating: 5 }
  ]
};

// Service-specific process steps
export const serviceProcessSteps = {
  trademark: [
    { step: 'Step 1', title: 'Consultation & Search', description: 'We review your trademark and conduct a comprehensive database search to ensure availability and registrability.' },
    { step: 'Step 2', title: 'Application Filing', description: 'Our experts prepare and file your trademark application with accurate classifications, descriptions, and specimen.' },
    { step: 'Step 3', title: 'Registration & Protection', description: 'We monitor your application, handle office actions, and secure your federal trademark registration.' }
  ],
  copyright: [
    { step: 'Step 1', title: 'Work Assessment', description: 'We evaluate your creative work and determine the appropriate copyright classification and filing strategy.' },
    { step: 'Step 2', title: 'Application Submission', description: 'We prepare and submit your copyright application to the U.S. Copyright Office with all required documentation.' },
    { step: 'Step 3', title: 'Certificate Delivery', description: 'Upon approval, we deliver your official copyright registration certificate for your records and protection.' }
  ],
  patent: [
    { step: 'Step 1', title: 'Prior Art Search', description: 'We conduct thorough patent searches to identify existing patents and assess the novelty of your invention.' },
    { step: 'Step 2', title: 'Application Drafting', description: 'Our patent experts draft comprehensive patent applications with detailed descriptions, claims, and drawings.' },
    { step: 'Step 3', title: 'Prosecution & Approval', description: 'We handle USPTO office actions and prosecution to secure your patent grant and protection rights.' }
  ],
  company: [
    { step: 'Step 1', title: 'Entity Selection', description: 'We help you choose the right business structure (LLC, Corporation, etc.) based on your specific needs.' },
    { step: 'Step 2', title: 'Document Preparation', description: 'We prepare all necessary formation documents, articles of organization, and operating agreements.' },
    { step: 'Step 3', title: 'State Filing & Setup', description: 'We file with the state, obtain your EIN, and complete all necessary registrations for your business.' }
  ],
  search: [
    { step: 'Step 1', title: 'Initial Screening', description: 'We perform preliminary searches to identify obvious conflicts and assess initial trademark viability.' },
    { step: 'Step 2', title: 'Comprehensive Search', description: 'We conduct extensive searches across federal, state, and common law databases for potential conflicts.' },
    { step: 'Step 3', title: 'Detailed Report', description: 'We provide a comprehensive report with our findings, analysis, and recommendations for moving forward.' }
  ],
  amazon: [
    { step: 'Step 1', title: 'Eligibility Check', description: 'We verify your trademark registration status and ensure eligibility for Amazon Brand Registry enrollment.' },
    { step: 'Step 2', title: 'Account Setup', description: 'We assist with Amazon Brand Registry application, documentation submission, and verification process.' },
    { step: 'Step 3', title: 'Brand Protection', description: 'Upon approval, we help you utilize Amazon brand protection tools and monitoring features.' }
  ]
};